import React from "react";
import { sanitizeHtml } from "../sanitize";

const RichTextBlock = {
  label: "RichText",
  fields: {
    richtext: { type: "richtext" },
  },
  defaultProps: {
    richtext: "<h2>Heading</h2><p>Body</p>",
  },
  render: ({ richtext }) => {
    return (
      <>
        {richtext && (
          typeof richtext === "string" ? (
            <div
              className="mt-2 prose max-w-none"
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(richtext) }}
            />
          ) : (
            <div className="mt-2 prose max-w-none">
              {richtext}
            </div>
          )
        )}
      </>
    );
  },
};

export default RichTextBlock;
